<div *ngVar="getControl(field) as control">
  <div *ngIf="control?.errors && control?.touched" class="invalid-feedback">
    <div *ngIf="control?.errors.required">{{ error.required }}</div>
    <div *ngIf="control?.errors.pattern">{{ error.pattern }}</div>
    <div *ngIf="control?.errors.maxlength">{{ error.maxLength }}</div>
    <div *ngIf="control?.errors.minlength">{{ error.minLength }}</div>
    <div *ngIf="control?.errors.max">{{ error.max }}</div>
    <div *ngIf="control?.errors.min">{{ error.min }}</div>
    <div *ngIf="control?.errors.invalid">{{ error.invalid }}</div>
    <div *ngIf="control?.errors.email">{{ error.email }}</div>
    <div *ngIf="control?.errors.invalidDob">{{ error.invalidDob }}</div>
    <div *ngIf="control?.errors.futureDate">{{ error.futureDate }}</div>
    <div *ngIf="control?.errors.countryCodeInvalid">{{ error.countryCodeInvalid }}</div>
    <div *ngIf="control?.errors.invalidPassword">{{ error.invalidPassword }}</div>
    <div *ngIf="control?.errors.passwordMismatch">{{ error.passwordMismatch }}</div>
  </div>
</div>
